export const SET_USER = 'SET_USER';
export const SET_HISTORY_KEYWORDS = 'SET_HISTORY_KEYWORDS'
export const SET_INS_ID = 'SET_INS_ID'
export const SET_DOMAIN_MAP = 'SET_DOMAIN_MAP'